module.exports = __webpack_public_path__ + "static/563c8b9b0fb5bd192bb632f1d851fd6d-87f958558bd35b8ef93d492b24b69c26.woff2";